<nf-grid-wrapper
  [gridApi]="api"
  [hideClearAll]="true"
  [hideSearch]="true"
  (filtersCleared)="filtersCleared.emit()"
  role="group"
  attr.aria-label="Accounts"
>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Accounts</h2>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right>
    <div id="header-toolbar-container" class="d-flex justify-content-end">
      <div class="header-toolbar-item">
        <nf-form-control compact>
          <nf-datepicker
            id="reconDateInput"
            name="reconDateInput"
            [formControl]="reconDateControl"
            [format]="dateFormat"
            [ngbTooltip]="
              isReconDateOutside
                ? 'WARNING: The date in this field is not equal to the current Recon Date'
                : 'Recon Date'
            "
            placement="bottom"
            [class.old-recon-date-error]="isReconDateOutside"
          >
          </nf-datepicker>
        </nf-form-control>
      </div>

      <div class="header-toolbar-item">
        <nf-form-control compact for="quickSearchAccountIds">
          <input
            type="text"
            id="quick-search-account-ids"
            class="form-control"
            [formControl]="quickSearchAccountIds"
            placeholder="Account Ids (e.g. 4,6)"
          />
        </nf-form-control>
      </div>

      <div class="header-toolbar-item">
        <input
          type="text"
          id="quick-search"
          class="form-control"
          [formControl]="quickSearch"
          placeholder="Search table..."
        />
      </div>
      <hs-account-list-filter-actions
        [filterCount]="filterCount"
        [gridApi]="this.api"
        [advancedFilterContextValue]="this.advancedFilterContext"
        (exportToExcel)="exportToExcel()"
      ></hs-account-list-filter-actions>
      <div class="header-toolbar-item">
        <hs-filter-modal-controls
          [filterCount]="filterCount"
          [disableClearButton]="!clearFiltersEnabled"
          [showBackButton]="true"
          [disableBackButton]="revertFilterService.disableRevert"
          (openFilterModalEvent)="launchFiltersModal()"
          (clearFiltersEvent)="clearFilters()"
          [showReloadButton]="true"
          (reloadTableEvent)="reloadTable()"
          (backEvent)="revertToPreviousFilters()"
        >
        </hs-filter-modal-controls>
      </div>
    </div>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-ag-grid
      [autoResize]="false"
      [gridOptions]="gridOptions"
      [gridModules]="gridModules"
    ></nf-ag-grid>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
